// @flow
import { isEqual, toString } from "lodash";
import isEmpty from "./is_empty";

export default (conditionValue: any) => (fieldValue: any) =>
  toString(conditionValue) === "EMPTY"
    ? isEmpty(fieldValue)
    : isEqual(toString(conditionValue), toString(fieldValue));
